export const formatSurnameIcaro = (value?: string): string => {
  if (!value) {
    return '';
  }

  return value.split('/')[0]?.trim() || '';
};

export const formatNameIcaro = (value?: string): string => {
  if (!value) {
    return '';
  }

  return value.split('/')[1]?.trim() || '';
};
